import { useMemo } from 'react';
const useDripActions = (status, hasDraftVersion) => useMemo(() => {
    if (!status) {
        return { canValidate: false, canActivate: false, canPause: false };
    }
    return {
        canValidate: true,
        canActivate: status === 'DRAFT' ||
            status === 'PAUSED' ||
            (status === 'ACTIVE' && hasDraftVersion),
        canPause: status === 'ACTIVE'
    };
}, [status, hasDraftVersion]);
export default useDripActions;
